"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cStyleRuleOptions = void 0;
exports.cStyleRuleOptions = [
    'header.color.background',
    'header.color.tabs.active',
    'header.color.tabs.link',
    'header.color.tabs.icons',
    'header.color.pages.backgroundColour',
    'header.color.tabs.modules.marker',
    'header.color.tabs.activeLink',
    'header.color.pages.link',
    'header.color.pages.activeLink',
    'header.color.tabs.pages.marker',
    'footer.color.background',
    'footer.color.link',
    'header.color.pages.backgroundColourActive',
    'body.color.background',
    'theme.dark.header.color.background',
    'theme.dark.header.color.tabs.active',
    'theme.dark.header.color.tabs.link',
    'theme.dark.header.color.tabs.icons',
    'theme.dark.header.color.pages.backgroundColour',
    'theme.dark.header.color.tabs.modules.marker',
    'theme.dark.header.color.tabs.activeLink',
    'theme.dark.header.color.pages.link',
    'theme.dark.header.color.tabs.pages.marker',
    'theme.dark.footer.color.background',
    'theme.dark.footer.color.link',
    'theme.dark.header.color.pages.backgroundColourActive',
    'theme.dark.body.color.background',
    'theme.dark.header.color.pages.activeLink'
];
